import React from 'react';
import {Heading, Box, VStack, HStack, Text, View} from 'native-base';
import {BolivarIcon, DollarIcon} from '../../../../../components/icons';
import {IBalanceDetail} from '../../../../../interfaces/dtos';

interface IHeaderProps {
  detail: IBalanceDetail;
}

const HeaderSection = (props: IHeaderProps) => {
  const {detail} = props;

  return (
    <Box paddingX={8}>
      <VStack flex={1}>
        <HStack space={5}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box height="6" justifyContent="center">
              <Heading size="sm" fontWeight="medium" color="#4C4C4C">
                {detail.id}
              </Heading>
            </Box>
            <Box justifyContent="center" marginTop={1}>
              <Text color="#99A2B4" fontSize={'sm'} numberOfLines={3}>
                {`${detail.type.label}: ${detail.summary}`}
              </Text>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <DollarIcon />
              </Box>
              <Box height="6" justifyContent="center" marginTop={1}>
                <BolivarIcon />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="lg">
                  {detail.amount.foreign}
                </Text>
              </View>
              <Box
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center"
                marginTop={1}>
                <Text fontWeight="bold" color="#06355E" fontSize="lg">
                  {detail.amount.local}
                </Text>
              </Box>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};
export default HeaderSection;
